<!--
*   Copyright (c) 2020 BuserNet Consulting LLC
*   All rights reserved.
 -->
<template>
  <ion-page class="ion-page ion-page-invisible">
    <SentinelElement />
    <ion-header>
      <ion-toolbar color="dark">
        <ion-buttons slot="start">
          <menu-button />
        </ion-buttons>
        <ion-title>
          Preferences
        </ion-title>
        <ion-buttons slot="end">
          <ion-button
            fill="solid"
            color="secondary"
            class="app-tour-button"
            @click="showtour()"
          >
            <ion-icon :icon="helpCircle" />
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list v-if="settings">
        <ion-radio-group
          id="timezonePref"
          v-model="settings.timeZone"
        >
          <div class="custom-divider">
            Timezone
          </div>
          <ion-item>
            <ion-label>Device default ({{ timeZoneShort }})</ion-label>
            <ion-radio
              slot="end"
              color="primary"
              value="L"
            />
          </ion-item>
          <ion-item>
            <ion-label>Zulu (GMT)</ion-label>
            <ion-radio
              slot="end"
              color="primary"
              value="Z"
            />
          </ion-item>
        </ion-radio-group>
        <ion-radio-group
          id="tempUnitPref"
          v-model="settings.temperatureUnit"
        >
          <div class="custom-divider">
            Temperature Unit
          </div>
          <ion-item>
            <ion-label>Fahrenheit</ion-label>
            <ion-radio
              slot="end"
              color="primary"
              value="F"
            />
          </ion-item>
          <ion-item>
            <ion-label>Celsius</ion-label>
            <ion-radio
              slot="end"
              color="primary"
              value="C"
            />
          </ion-item>
        </ion-radio-group>
        <div class="custom-divider">
          Aircraft
        </div>
        <ion-item id="groundSpeedPref">
          <ion-label>Ground speed (knots)</ion-label>
          <ion-input
            v-model.number="settings.groundSpeed"
            type="number"
            placeholder="Speed in knots"
            @ionBlur="groundSpeedValidation()"
          />
        </ion-item>
        <div
          id="weatherSourceApiPref"
          class="custom-divider collapse-divider"
          @click="showAdvanced = !showAdvanced"
        >
          Advanced
          <font-awesome-icon
            v-if="!showAdvanced"
            slot="start"
            icon="angle-down"
            class="floatright"
          />
          <font-awesome-icon
            v-if="showAdvanced"
            slot="start"
            icon="angle-up"
            class="floatright"
          />
        </div>
        <div v-show="showAdvanced">
          <ion-item>
            <ion-label>Show arrowheads on wind barbs</ion-label>
            <ion-toggle
              v-model="settings.showBarbHead"
              color="primary"
            />
          </ion-item>
          <ion-item>
            <ion-label>Ignore midpoint weather reports</ion-label>
            <ion-toggle
              v-model="settings.ignoreMidpoints"
              color="primary"
            />
          </ion-item>
          <div class="custom-divider">
            7-Day
          </div>
          <ion-item>
            <ion-label>Sync selected airport with Airport view</ion-label>
            <ion-toggle
              v-model="settings.synch7DayAirport"
              color="primary"
            />
          </ion-item>
        </div>
      </ion-list>
    </ion-content>
    <v-tour
      name="viewTour"
      :steps="toursteps"
      :callbacks="tourCallbacks"
    />
  </ion-page>
</template>
<script>
import {
  IonRadioGroup,
  IonRadio,
  IonContent,
  IonHeader,
  IonList,
  IonItem,
  IonInput,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonButton,
  IonToggle,
  IonIcon,
  IonLabel,
} from '@ionic/vue';
import { helpCircle } from 'ionicons/icons';
import ConfigApplicationSettings from '../config/application.config';
import HelpBoxConfig from '../components/HelpBox/HelpBox.config';
import AppConst from '../constants/app.constant';
import utilityService from '../services/utility.service';

export default {
  name: 'Preferences',
  components: {
    IonRadioGroup,
    IonRadio,
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonButton,
    IonToggle,
    IonButtons,
    IonIcon,
    IonLabel,
    IonList,
    IonItem,
    IonInput,
  },
  data() {
    return {
      helpCircle,
      settings: null,
      timeZone: 'L',
      showAdvanced: false,
      toursteps: HelpBoxConfig['app.settings'].steps,
    };
  },
  computed: {
    timeZoneShort() {
      return utilityService.getTimeZoneShort();
    },
  },
  methods: {
    ionViewDidEnter() {
      this.settings = { ...ConfigApplicationSettings.settings };
      utilityService.changeTourElementPosition();
    },
    ionViewWillLeave() {
      utilityService.stopTour();
      // Before destory i.e. changing view save settings to Localstorage
      this.savePreferences();
    },
    savePreferences() {
      ConfigApplicationSettings.settings = { ...this.settings };
      ConfigApplicationSettings.setapplicationConfig();
    },
    groundSpeedValidation() {
      if (this.settings) {
        const groundSpeed = parseInt(this.settings.groundSpeed, 10);
        this.settings.groundSpeed = groundSpeed;
      }
      if (!this.settings.groundSpeed) {
        this.settings.groundSpeed = AppConst.defaultGroundSpeed;
      } else if (this.settings.groundSpeed < AppConst.minGroundSpeed) {
        this.settings.groundSpeed = AppConst.minGroundSpeed;
      } else if (this.settings.groundSpeed > AppConst.maxGroundSpeed) {
        this.settings.groundSpeed = AppConst.maxGroundSpeed;
      }
    },
    showtour() {
      this.$tours.viewTour.start();
    },
  },
};
</script>
